export const mesesCatalogo = [
  { id: 1, nombre: "Enero" },
  { id: 2, nombre: "Febrero" },
  { id: 3, nombre: "Marzo" },
  { id: 4, nombre: "Abril" },
  { id: 5, nombre: "Mayo" },
  { id: 6, nombre: "Junio" },
  { id: 7, nombre: "Julio" },
  { id: 8, nombre: "Agosto" },
  { id: 9, nombre: "Septiembre" },
  { id: 10, nombre: "Octubre" },
  { id: 11, nombre: "Noviembre" },
  { id: 12, nombre: "Diciembre" },
];

export const tipoUnidadCatalogo = [
  { id: 1, nombre: "Camiones" },
  { id: 3, nombre: "Motos" },
  { id: 4, nombre: "Autos" },
];

export const generarCatalogoAnios = () => {
  const anioActual = new Date().getFullYear();
  const anioMinimo = 2016;
  const catalogo = [];

  for (let i = 0; i < 5; i++) {
    const anio = anioActual - i;
    if (anio < anioMinimo) break;
    catalogo.push({ id: anio, nombre: anio.toString() });
  }

  return catalogo;
};
